import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    flex
    flex-col
    gap-4
  `
)
